import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';

export default class extends Controller {
  static get targets() {
    return ['editable', 'select'];
  } 

  connect() {
    this.toggleEdit();
  }
  
  toggleEdit() {
    let field = $(this.selectTarget);
    let editable = $(this.editableTarget);
    let selectedOption = field.find("option:selected");
    if (field.val()=="?" || (field.val()=='' && editable.val()!='')) {
      field.attr('disabled', true).hide();
      editable.attr('disabled', false).show().focus();      
    } else {
      field.attr('disabled', false).show();
      editable.attr('disabled', true).val('').hide();      
    }
  }
}
